// extracted by mini-css-extract-plugin
export default {"tool":"style_tool__dGqQC"};